if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			// Product thumbnails
			this.querySelectorAll('[data-js-product-tabs]').forEach(tabs=>{
				tabs.querySelectorAll('label').forEach(tab=>{
					tab.addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							tab.click();
						}
					});
				})
			})

			this.querySelectorAll('.product-variant__item--color').forEach(elm=>{
				const selectedColor = elm.querySelector('input[type="radio"][checked][data-selected]');
				if ( selectedColor ) {
					selectedColor.closest('[data-js-product-variant]').querySelector('.product-variant__item-text-label').innerHTML = selectedColor.value;
				}
			});

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).getBoundingClientRect().top,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							this._pauseAllMedia();
							this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('navigation', e=>{
					this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`));
				})
				this.productSlider.addEventListener('change', e=>{
					this._pauseAllMedia();
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', ()=>{
					this.productImageSlides = this.productSlider.querySelectorAll('.product-gallery-item');
					this.productImages = this.productSlider.querySelectorAll('.product-media-image');
				});
				this.productSlider.addEventListener('scroll', ()=>{
					const scrollX = -this.productSlider.element.scrollLeft;
					this.productImageSlides.forEach((slide,i)=>{
						const img = this.productImages[i];
						if ( img ) {
							const slideX = slide.offsetLeft;
							img.style.transform = `translateX(${( slideX + scrollX ) * -1/3}px)`;
						}
					});
				});

				this.productSlider.addEventListener('ready', (e)=>{
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}
				});

			}

			this.productGallery.querySelectorAll('[data-js-video-popup-link]').forEach(elm=>{
				elm.addEventListener('click', ()=>{
					this._pauseAllMedia();
				});
			})

			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});

				// refresh color
				this.querySelectorAll('.product-variant__item--radio input').forEach(input=>{
					input.addEventListener('click', () => {
						const inputParent = input.closest('.product-variant__item--radio');
						if ( inputParent.classList.contains('product-variant__item--color' ) ) {
							inputParent.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = input.value;
						}
					})
				});

			}
			
			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
							if ( document.getElementById('cart-recommendations-sidebar') ) {
							document.getElementById('cart-recommendations-sidebar').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
			if ( addToCartButton ) {

				// hide buy now button if stock disabled

				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });

			}

			// truncated descriptions

			if ( this.querySelector('[data-js-show-more]') ) {
				const showMore = this.querySelector('[data-js-show-more]');
				const productDescription = this.querySelector('.product__description');
				showMore.addEventListener('click', ()=>{
					productDescription.classList.toggle('product__description--truncated-initial');
					if ( productDescription.classList.contains('product__description--truncated-initial') ) {
						showMore.querySelector('.button__text').textContent = showMore.dataset.labelShowLess;
					} else {
						showMore.querySelector('.button__text').textContent = showMore.dataset.labelShowMore;
					}
				})
			}

			// recommended products
			
			this.querySelector('product-recommendations')?.addEventListener('product-recommendations-loaded', ()=>{
				this.querySelector('product-recommendations').classList.add('product-text-element--with-borders');
			});
			this.querySelector('product-recommendations')?.addEventListener('product-recommendations-error', ()=>{
				this.querySelector('product-recommendations').remove();
			});


			$("body").on("click", ".tab_sel" ,function(e){
				e.preventDefault();
				var type = $(this).attr("data-type");
				$('[data-type').removeClass('active');
				$('[data-type="'+ type +'"]').addClass('active');
			});

			$("body").on("click", ".prize_header", function (e) {
				e.preventDefault();
				console.log("active");
				$(this).toggleClass("active");
				$(this).closest(".prize_dropdown_wrapper").find(".prize_tickets").slideToggle();
			});

			// ===== CONFIG =====
			window.luxuryportals.total_breaks = [];
			const total_inventory = Number($('input[name="total_qty"]').val()); // total tickets
			let current_qty = Number($('input[name="current_qty"]').val()); // remaining tickets in stock (example from your scenario)

			const base_price = Number($('input[name="variant_base_price"]').val());
			const max_limit = Number($(".range_min_max .max_val").text());

			function calculateTotalPrice(orderQty, currentStock) {
				let totalStock = total_inventory;        
				let soldAlready = totalStock - currentStock;   // how many tickets sold
				let total = 0;
				let breakdown = [];

				let tiers = [...price_list].sort((a,b)=>a.qty - b.qty);

				for (let i = 0; i < orderQty; i++) {
					let position = soldAlready + 1;
					let price = base_price;

					for (let t of tiers) {
						if (position > t.qty) {
							price = Number(t.price.amount);
						}
					}

					total += price;

					let type = (price > base_price) ? "increased" : "native";

					if (breakdown.length === 0 || breakdown[breakdown.length-1].price !== price) {
						breakdown.push({ qty: 1, price: price, type });
					} else {
						breakdown[breakdown.length - 1].qty++;
					}

					soldAlready++;
				}

				return { total, breakdown };
			}


			// ===== FRONTEND INTERACTION =====
			function update_price(val,data_t,range,tooltip) {
				change_tolltip(range,tooltip);
				console.log("val: " + val);
				console.log("current_qty: " + current_qty);
				const result = calculateTotalPrice(Number(val), current_qty);
				console.log(result);
				const total_amt = result.total * 100;
				let vol_tiers = [...volumn_data].sort((a,b)=>a.qty - b.qty);
				let per_apply = null;
				for (let t of vol_tiers) {
					if (val >= t.qty) {
						per_apply = Number(t.percentage);
					}
				}
				$(".btn_discount").removeClass("active");
				if(per_apply){
					per_apply = per_apply.toFixed(1);
					$(".btn_discount[data-per='"+ per_apply +"']").addClass("active");
					console.log('total_amt:' + total_amt);
					console.log('per_apply:' + per_apply);
					var final_amt = total_amt - ((Math.abs(total_amt) * per_apply) / 100);
					console.log('final_amt:' + final_amt);
					$(".total_price").html("<del>"+ data_t._formatMoney(Math.abs(total_amt), KROWN.settings.shop_money_format) +"</del> " + data_t._formatMoney(Math.abs(final_amt), KROWN.settings.shop_money_format));
				}else{
					$(".total_price").html(data_t._formatMoney(Math.abs(total_amt), KROWN.settings.shop_money_format));
				}
				$(".tc").html(val);
				const hasPriceChange = result.breakdown.some(item => item.price != base_price);
				if (hasPriceChange) {
					const breakdownHtml = result.breakdown
					.filter(b => b.qty > 0)
					.map(b => {
						const label = ""; 
							b.type === "native"
							? `<span style="color:green;">(Base)</span>`
							: `<span style="color:red;">(Increased)</span>`;
						return `<li>${b.qty} × ${data_t._formatMoney((b.price * 100), KROWN.settings.shop_money_format)} ${label}</li>`;
					}).join("");
					// $(".price-breakdown").html("<ul>" + breakdownHtml + "</ul>");
				} else {
					$(".price-breakdown").empty();
				}

				window.luxuryportals.total_breaks = result.breakdown;
				var found_new_p = 0;
				for (var j = 0; j < result.breakdown.length; j++){
					if(result.breakdown[j].type == "increased"){
						found_new_p = 1;
					}
				}
				var variant_id = data_t.querySelector('input[name="variant_wise_limit"]').getAttribute("data-variant_id");
				if(found_new_p == 1){
					$('product-form form[data-type="add-to-cart-form"][data-variant_id="'+ variant_id +'"]').addClass('add_hash_cart');
				}else{
					$('product-form form[data-type="add-to-cart-form"][data-variant_id="'+ variant_id +'"]').removeClass('add_hash_cart');
				}
				const limit = window.luxuryportals.variant_limits[variant_id] || 0;
				let cartQty = 0;
				window.luxuryportals.current_cart_qty.forEach(item => {
					if (item.id == variant_id) {
						cartQty += item.quantity;
					}
				});
				const availableQty = limit - cartQty;
				$(".qty_err").remove();
				if(limit == 0){
					$('product-form form[data-type="add-to-cart-form"][data-variant_id="'+ variant_id +'"] [name="add"]').addClass('btn_disabled').before("<p class='qty_err'>❌ You cannot add any quantity.</p>");
				}else if (val > availableQty) {
					$('product-form form[data-type="add-to-cart-form"][data-variant_id="'+ variant_id +'"] [name="add"]').addClass('btn_disabled').before("<p class='qty_err'>❌ You cannot add more than " + limit + " quantity.</p>");
				} else {
					$('product-form form[data-type="add-to-cart-form"][data-variant_id="'+ variant_id +'"] [name="add"]').removeClass('btn_disabled');
					
				}
			}

			function change_tolltip(range,tooltip){
				const newValue = Number( (range.value - range.min) * 100 / (range.max - range.min) ),
				newPosition = 8 - (newValue * 0.16);
				if(tooltip){
					tooltip.innerHTML = `<span>${range.value}</span>`;
					tooltip.style.left = `calc(${newValue}% + (${newPosition}px))`;
					const percent = (range.value - range.min) / (range.max - range.min) * 100;
					range.style.setProperty('--val', `${percent}%`);
				}
			}

			const range = document.getElementById("range");
			const tooltip = document.getElementById('tooltip');
			const rangeValue = document.getElementById("rangeValue");
			const data_t = this;
			if(range && rangeValue){
				range.addEventListener("input", () => {
					rangeValue.value = range.value;
					update_price(range.value,data_t,range,tooltip);
				});

				rangeValue.addEventListener("input", () => {
					let val = Number(rangeValue.value);
					if (val < range.min) val = range.min;
					if (val > range.max) val = range.max;
					rangeValue.value = val;
					range.value = val;
					update_price(val,data_t,range,tooltip);
				});
			}
			$("body").on("click", ".discount_boxes .btn_discount", function (e) {
				e.preventDefault();
				var per = $(this).attr("data-per");
				var qty = $(this).attr("data-qty");
				$("#rangeValue").val(qty);
				if(range){
					range.value = qty;
				}
				update_price(qty,data_t,range,tooltip);
			});
			$("body").on("click", ".plus_minus", function (e) {
				e.preventDefault();
				var current_val = Number($("#rangeValue").val());
				if ($(this).hasClass("_minus")) {
				if (current_val > 1) current_val--;
				} else {
				if (current_val < max_limit) current_val++;
				}
				$("#rangeValue").val(current_val);
				if(range){
					range.value = current_val;
				}
				update_price(current_val,data_t,range,tooltip);
			});
			
			if(typeof(price_list) !== 'undefined'){
				var default_qty = 1;
				if($('.btn_discount.active').length > 0){
					default_qty = $('.btn_discount.active').attr("data-qty");
				}
				update_price(default_qty,data_t,range,tooltip);
			}
			
		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {
				
				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							variantImg.scrollIntoView({behavior: 'auto', block: 'center'});
						}
					}
				}

			}

			this._pauseAllMedia();

		}

		_pauseAllMedia(){
			document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
			document.querySelectorAll('.product-gallery product-model').forEach(model => {
				if ( model.modelViewerUI && model.modelViewerUI.pause ) 
					model.modelViewerUI.pause()
			});
		}
		
		_playMedia(media){
			switch ( media.dataset.productMediaType ) {
				case 'video':
					if ( media.querySelector('video') ) {
						media.querySelector('video').play();
					}
					break;
				case 'external_video-youtube':
					if ( media.querySelector('.js-youtube') ) {
						media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}
					break;
				case 'external_video-vimeo':
					if ( media.querySelector('.js-vimeo') ) {
						media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					}
					break;
			}
		}

		_formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount + KROWN.settings.iso_code;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}